import { useTranslation } from 'react-i18next';
import styles from './ViewOnlyNote.module.css';

/**
 * The one-line "view only" note an ops executive sees on a screen whose
 * changes are OPS_MANAGER only (dnm-work#161, R67). The data stays visible;
 * the screen hides or disables its controls and shows this note at the top.
 */
export function ViewOnlyNote() {
  const { t } = useTranslation();
  return (
    <p role="note" className={styles.note}>
      {t('ui.viewOnlyNote.text')}
    </p>
  );
}
